import { apiIdentityUrl } from "../../../lib/tenantOrigin";
import { Box } from "../../Box";
import { Text } from "../../Text";
import { CopyableField } from "./CopyableField";
import { SubLabel } from "./shared";
import { oidcRedirectUri } from "./urls";

export function CallbackUrl({
  providerId,
  isNew,
}: {
  providerId: string;
  isNew?: boolean;
}) {
  return (
    <>
      <SubLabel>For your identity provider</SubLabel>
      {isNew ? (
        <Box horizontal={8}>
          <Text variant="text-small" color="var(--text-secondary)">
            The redirect URI to configure your IdP will appear here once you add
            the provider.
          </Text>
        </Box>
      ) : (
        <CopyableField
          label="Redirect URI"
          hint="Add this to your IdP’s application settings"
          value={oidcRedirectUri(apiIdentityUrl(), providerId)}
        />
      )}
    </>
  );
}
